import { Permission } from '@cims-online/shared'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useConcreteTestSetTrackerContext } from '../ConcreteTestSetTrackerContext'
import { ConcreteTestSet } from '../ConcreteTestSetTrackerContext/types'

export function useCustom(): CustomRowActionOptions<ConcreteTestSet>[] {
  const { pdfModal, uploadModal, breakDataModal } =
    useConcreteTestSetTrackerContext()
  return [
    {
      permission: Permission.UploadConcretePacketFile,
      text: 'Upload Files',
      onClick: uploadModal.toggle,
    },
    {
      permission: Permission.CreateConcretePacket,
      text: 'Create Packet',
      onClick: pdfModal.toggle,
    },
    {
      permission: Permission.EditConcreteBreakData,
      text: 'Edit Break Data',
      onClick: breakDataModal.toggle,
      hidden: ({ concretePlacements, concreteTests }) =>
        !concretePlacements.flatMap(
          ({ concreteCoreMeasurements }) => concreteCoreMeasurements
        ).length && !concreteTests.length,
    },
  ]
}
